import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/hero/HeroSection'; 
import FeaturesSection from '../components/features/FeaturesSection';
import PortfolioShowcase from '../components/portfolio/PortfolioShowcase';
import TestimonialsSection from '../components/testimonials/TestimonialsSection';
import ContactSection from '../components/contact/ContactSection';

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>iModernize - Professional Web Design & Development Services</title>
        <meta 
          name="description" 
          content="Professional web design and development services. We create beautiful, functional websites that help your business grow online with cutting-edge technology and stunning design." 
        />
        <meta name="keywords" content="web design, web development, modern websites, professional design, react development, UI/UX design" />
      </Helmet>

      {/* Advanced Hero Section */}
      <HeroSection />

      {/* Features Showcase - Hidden for now */}
      {/* <FeaturesSection /> */}

      {/* Portfolio Showcase */}
      <PortfolioShowcase />

      {/* Client Testimonials */}
      <TestimonialsSection />

      {/* Contact Section */}
      <ContactSection />
    </>
  );
};

export default HomePage;